import CircularProgress from '@mui/material/CircularProgress'
import clsx from 'clsx'

import css from './FullLoader.module.scss'

export function FullLoader({
	className,
	size = 60
}: { className?: string; size?: number }) {
	return (
		<div className={clsx(css.wrapper, className)}>
			<CircularProgress
				classes={{ colorPrimary: 'material-loader' }}
				color='primary'
				size={size}
			/>
		</div>
	)
}
